var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[(_vm.googleAccountExist)?_c('a',{staticClass:"nav-link",attrs:{"href":_vm.linkGoogleAccount}},[_vm._v("\n    "+_vm._s(_vm.$t("googleConfiguration"))+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }